const RuleRow = ({ ok, text }) => (
  <div style={{display:"flex", alignItems:"center", gap:8, fontSize:13}}>
    <span style={{color: ok ? "#2e7d32" : "#d32f2f"}}>{ok ? "✓" : "✗"}</span>
    <span>{text}</span>
  </div>
);

export default function PasswordPolicyChecklist({ password }) {
  const hasLower   = /[a-z]/.test(password);
  const hasUpper   = /[A-Z]/.test(password);
  const hasDigit   = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);
  const noSpaces   = !/\s/.test(password);
  const lenOK      = (password?.length || 0) >= 10;

  return (
    <div style={{display:"grid", gap:4, marginTop:8}}>
      <RuleRow ok={lenOK}      text="Mindestens 10 Zeichen" />
      <RuleRow ok={hasLower}   text="Mindestens 1 Kleinbuchstabe" />
      <RuleRow ok={hasUpper}   text="Mindestens 1 Großbuchstabe" />
      <RuleRow ok={hasDigit}   text="Mindestens 1 Ziffer" />
      <RuleRow ok={hasSpecial} text="Mindestens 1 Sonderzeichen" />
      <RuleRow ok={noSpaces}   text="Keine Leerzeichen" />
    </div>
  );
}
